module.exports = __webpack_public_path__ + "img/ci_naver.e3a34e11.svg";